export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";